import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall } from "@components/Typography";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";

export const AvailableFundsModal = () => {
  const { dismiss } = useModal();

  const props: OverlayProps = {
    title: i18n.t(Translations.AvailableFundsModalTitle),
    cta: {
      primary: {
        title: i18n.t(Translations.AvailableFundsModalPrimaryCTA),
        onClick: dismiss,
      },
    },
  };

  return (
    <Overlay {...props}>
      <BodySmall>{i18n.t(Translations.AvailableFundsModalItem1)}</BodySmall>
      <Spacing size={SpacingSizes.XS} />

      <BodySmall>{i18n.t(Translations.AvailableFundsModalItem2)}</BodySmall>
      <Spacing size={SpacingSizes.XS} />

      <BodySmall>{i18n.t(Translations.AvailableFundsModalItem3)}</BodySmall>
      <Spacing size={SpacingSizes.XS} />

      <BodySmall>{i18n.t(Translations.AvailableFundsModalItem4)}</BodySmall>
      <Spacing size={SpacingSizes.XS} />

      <BodySmall>{i18n.t(Translations.AvailableFundsModalItem5)}</BodySmall>
      <Spacing size={SpacingSizes.XS} />

      <BodySmall>{i18n.t(Translations.AvailableFundsModalItem6)}</BodySmall>
      <Spacing size={SpacingSizes.M} />
    </Overlay>
  );
};
